import * as React from 'react';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import styles from './Arrows.styl';
export const Arrows = ({ onPrevUp, onNextUp, onPrevDown, onNextDown, onPrevLeave, onNextLeave }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: styles.prevWrapper, onMouseDown: onPrevDown, onMouseUp: onPrevUp, onMouseLeave: onPrevLeave },
        React.createElement("div", { className: styles.prev },
            React.createElement(IconSVG, { name: 'chevron', customDimensions: true, className: styles.prevIcon }))),
    React.createElement("div", { className: styles.nextWrapper, onMouseDown: onNextDown, onMouseUp: onNextUp, onMouseLeave: onNextLeave },
        React.createElement("div", { className: styles.next },
            React.createElement(IconSVG, { name: 'chevron', customDimensions: true, className: styles.nextIcon })))));
